<template>
  <circle-statistic
    icon="euro_symbol"
    :title="$t('customs.dashboard.totalSales')"
    :sub-title="subtitle"
    :value="periodDiffPositiveValue"
    :text="formatPrice(totalRevenues, currency)"
    :color="color"
    :caption="
      periodDiffIsInfinity
        ? ''
        : $t('customs.dashboard.previousPeriod') + ' ' + formatPrice(totalRevenuesPrevious, currency)
    "
    :is-negative="Math.sign(percentagePeriodDiff) !== 1"
    :loading="loading"
  >
  </circle-statistic>
</template>

<script>
  import CircleStatistic from '../../components/Widgets/statistic/CircleStatistic'
  import { Helpers } from '../../mixins/Helpers.js'

  export default {
    name: 'RevenuesIndicator',
    mixins: [Helpers],
    components: {
      CircleStatistic
    },
    props: {
      loading: Boolean,
      totalRevenues: Number,
      totalRevenuesPrevious: Number,
      startDate: String,
      endDate: String,
      currency: String
    },
    data() {
      return {
        headersForCSV: ['IdStore', 'Store', 'TotalRevenues']
      }
    },
    computed: {
      percentagePeriodDiff() {
        let diff = ((this.totalRevenues - this.totalRevenuesPrevious) / this.totalRevenuesPrevious) * 100
        if (!isNaN(diff)) {
          return Math.round(diff)
        } else {
          return 0
        }
      },
      periodDiffPositiveValue() {
        let diff = this.percentagePeriodDiff
        if (diff < 0) {
          return -diff
        } else {
          return diff
        }
      },
      subtitle() {
        return this.percentagePeriodDiff === Infinity
          ? this.$t('customs.dashboard.unavailableDataForPreviousPeriod')
          : this.percentagePeriodDiff + '% ' + this.$t('customs.dashboard.vsPreviousPeriod')
      },
      periodDiffIsInfinity() {
        return this.percentagePeriodDiff === Infinity
      },
      color() {
        if (Math.sign(this.percentagePeriodDiff) === 1) {
          return 'green'
        } else if (Math.sign(this.percentagePeriodDiff) === -1) {
          return 'red'
        } else {
          return 'primary'
        }
      }
    }
  }
</script>

<style scoped></style>
